import { useEffect, useMemo, useState } from 'react'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import styles from './mhlShared.module.scss'

export const MHL_PAGE_SIZE = 15

export const usePagedRows = <T,>(items: T[], pageSize: number = MHL_PAGE_SIZE) => {
    const [page, setPage] = useState(1)
    const totalPages = Math.max(1, Math.ceil(items.length / pageSize))
    const safePage = Math.min(page, totalPages)

    useEffect(() => {
        setPage(1)
    }, [items])

    const rows = useMemo(
        () => items.slice((safePage - 1) * pageSize, safePage * pageSize),
        [items, safePage, pageSize],
    )

    return { rows, page: safePage, totalPages, setPage, pageSize }
}

export const TablePagination = ({
    page,
    totalPages,
    total,
    pageSize,
    onChange,
}: {
    page: number
    totalPages: number
    total: number
    pageSize: number
    onChange: (page: number) => void
}) => {
    if (totalPages <= 1) return null
    return (
        <div className={styles.pagination}>
            <span className={styles.pageInfo}>
                Showing {(page - 1) * pageSize + 1}–{Math.min(page * pageSize, total)} of {total}
            </span>
            <div className={styles.pageButtons}>
                <button
                    type="button"
                    className={`${styles.btn} ${styles.btnSmall}`}
                    onClick={() => onChange(Math.max(1, page - 1))}
                    disabled={page === 1}
                >
                    <FaChevronLeft size={10} /> Prev
                </button>
                <button
                    type="button"
                    className={`${styles.btn} ${styles.btnSmall}`}
                    onClick={() => onChange(Math.min(totalPages, page + 1))}
                    disabled={page === totalPages}
                >
                    Next <FaChevronRight size={10} />
                </button>
            </div>
        </div>
    )
}
